import { Box, Button, FormControl, FormGroup, FormLabel, Modal, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { adjustCustomerPoint } from "services/CustomerService";

interface CustomerAdjustmentPointModalProps {
    open: boolean;
    onClose: () => void;
    customerId: number;
    currentPoint: number;
    accumulatedPoint: number;
    reloadTableData: () => Promise<void>;
}

export type CustomerAdjustmentPoint = {
    adjustAccumulatedPoint: number;
    adjustCurrentPoint: number;
    note: string;
}

const CustomerAdjustmentPointModal = ({ open, onClose, customerId, currentPoint, accumulatedPoint, reloadTableData }: CustomerAdjustmentPointModalProps) => {
    const [adjustmentPoint, setAdjustmentPoint] = useState<CustomerAdjustmentPoint>({
        adjustAccumulatedPoint: 0,
        adjustCurrentPoint: 0,
        note: ''
    });
    const [errors, setErrors] = useState<{ [key: string]: string }>({});

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setAdjustmentPoint({ ...adjustmentPoint, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        await adjustCustomerPoint(adjustmentPoint, customerId);
        await reloadTableData();
        setErrors({});
        onClose();
    }

    return <Modal open={open} onClose={onClose}>
        <Box
            component="form"
            sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'background.paper', boxShadow: 24, p: 4 }}
            onSubmit={handleSubmit}
            >
                <Typography variant="h6">Cập nhật điểm khách hàng</Typography>
                <FormGroup>
                    <FormControl fullWidth sx={{ mt: 2 }}>
                        <FormLabel htmlFor="adjustCurrentPoint">Điểm hiện có ({currentPoint})</FormLabel>
                        <TextField
                        id="adjustCurrentPoint"
                        type="number"
                        name="adjustCurrentPoint"
                        placeholder="Điểm hiện có"
                        required
                        // fullWidth
                        variant="outlined"
                        value={adjustmentPoint.adjustCurrentPoint}
                        onChange={handleChange}
                        error={!!errors.adjustCurrentPoint}
                        helperText={errors.adjustCurrentPoint}
                        color={errors.adjustCurrentPoint ? 'error' : 'primary'}
                        />
                    </FormControl>
                    <FormControl fullWidth sx={{ mt: 2 }}>
                        <FormLabel htmlFor="adjustCurrentPoint">Điểm tích lũy ({accumulatedPoint})</FormLabel>
                        <TextField
                        id="adjustAccumulatedPoint"
                        type="number"
                        name="adjustAccumulatedPoint"
                        placeholder="Điểm tích lũy"
                        required
                        // fullWidth
                        variant="outlined"
                        value={adjustmentPoint.adjustAccumulatedPoint}
                        onChange={handleChange}
                        error={!!errors.adjustAccumulatedPoint}
                        helperText={errors.adjustAccumulatedPoint}
                        color={errors.adjustAccumulatedPoint ? 'error' : 'primary'}
                        />
                    </FormControl>
                    <FormControl fullWidth sx={{ mt: 2 }}>
                        <FormLabel htmlFor="phone">Ghi chú</FormLabel>
                        <TextField
                        id="note"
                        type="text"
                        name="note"
                        placeholder="Ghi chú"
                        required
                        // fullWidth
                        variant="outlined"
                        value={adjustmentPoint.note}
                        onChange={handleChange}
                        error={!!errors.note}
                        helperText={errors.note}
                        color={errors.note ? 'error' : 'primary'}
                        multiline
                        rows={4}
                        />
                    </FormControl>
                </FormGroup>
                <Box mt={2} display="flex" justifyContent="flex-end">
                <Button onClick={onClose} sx={{ mr: 1 }}>Cancel</Button>
                <Button type="submit" variant="contained" color="primary">Xác nhận</Button>
                </Box>
            </Box>
    </Modal>;
}

export default CustomerAdjustmentPointModal;